


import {Component, Prop, Vue} from 'vue-property-decorator';
import {mapState, mapGetters} from 'vuex';

import InputTextComponent from '@/shared/components/InputText.vue';
import SelectOptionsComponent from '@/shared/components/SelectOptions.vue';
import ButtonComponent from '@/shared/components/Button.vue';

import {Option} from '@/shared/models/view/option-viewmodel';

import studiesData from '../../data/studies';
import choicesData from '../../data/choices';

@Component({
    name: 'StudySelectView',
    components: {
        InputTextComponent,
        SelectOptionsComponent,
        ButtonComponent
    },
    computed: {
        ...mapState(['preform', 'isDisabled']),
        ...mapGetters('root', ['label'])
    }
})
export default class StudySelectViewComponent extends Vue {
    private labelModule = 'SelfServiceRegistration';
    public preform!: any;
    private studies = studiesData.map(({
                                           name,
                                           value
                                       }) => new Option(this.$store.getters['root/label'](this.labelModule, name), value));
    private yesNo = choicesData.map(({
                                         name,
                                         value
                                     }) => new Option(this.$store.getters['root/label'](this.labelModule, name), value));

    private initialized: boolean = false;
    
    mounted() {
        this.init();
    }
    
    private async init(): Promise<void> {
        let studyInUrl = this.getProgrammeParameterFromUrl();
        if(studyInUrl)
        {
            let study = this.getStudyFromDataFile(studyInUrl);
            if (study){
                await this.studyUpdate('study', study);
                this.$store.commit('setDisabled', true);
            }
        }
        
        this.initialized = true;
    }
    
    // Retrieves a valid study from the ../data/studies.ts
    // Equality check is ignoring casing
    private getStudyFromDataFile(studyName:string) : string | undefined {
        return studiesData
            .find(study => study.value.toLowerCase() === studyName.toLowerCase())?.value;
    }
    
    private getProgrammeParameterFromUrl(): string | null {
        return new URLSearchParams(window?.location?.search)?.get("programme");
    }
    
    private nextView(): void {
        this.setPreFormValue(
            'registrationType',
            (this.preform.followUpOne === 'yes' && this.preform.followUpTwo === 'yes') ? 'AdditionalModule' : this.preform.study);

        this.$store.commit('setActiveView', 'StudyInformationView');
    }

    private async studyUpdate(key: string, value: any): Promise<void> {
        await this.$store.dispatch('resetPreFormValues').then(() => {
            this.setPreFormValue(key, value);
        });
    }

    private setPreFormValue(key: string, value: any): void {
        this.$store.commit('setPreFormValue', {key, value});
    }

    private removePreFormValue(key: string, value: any): void {
        this.$store.commit('removePreFormValue', {key, value});
    }
}
